export interface CoreVersion {
  version: string;
  releaseDate?: string;
  changes: string[];
}

export const CORE_VERSIONS: CoreVersion[] = [
  {
    version: '2.27',
    releaseDate: '2025-12-01',
    changes: [
      'Versión inicial registrada del CORE de SynerLab.',
    ],
  },
  {
    version: '3.0',
    releaseDate: '2026-04-26',
    changes: [
      '**Módulo de Control de Calidad**: nuevo módulo para creación de materiales, lotes y controles por niveles, registro de resultados, gráficos Levey-Jennings, reglas de Westgard y Six Sigma básico.',
      '**Impresión y envío masivo de resultados**: se habilitan los servicios para procesar la impresión y el envío masivo de resultados.',
      '**Envío masivo de resultados por correo y WhatsApp**: se habilita el procesamiento automático y manual.',
      '**Envío de resultados a laboratorios de referencia**: se habilita la comunicación con laboratorios externos que también usan SynerLab a través del módulo de remisiones externas.',
      '**Inicio de sesión más seguro**: se incorpora la verificación reCAPTCHA durante la autenticación.',
      '**Registro de IPs de confianza**: se incorpora un registro de direcciones autorizadas para que los equipos dentro de la institución no requieran la verificación reCAPTCHA al iniciar sesión.',
      '**Mantenimientos sin limpiar caché**: al crear, modificar o eliminar elementos en el módulo de Mantenimientos ya no es necesario limpiar la caché — basta con cerrar sesión y volver a entrar.',
      '**Facturación electrónica y RIPS**: se corrigen problemas de cálculo de totales con decimales.',
      '**Nuevos filtros en preórdenes**: se habilita la búsqueda por contrato, facturado y RIPS.',
      '**Control de duplicidad de órdenes**: se evita que se generen órdenes duplicadas cuando provienen de fuentes externas como HIS o LIS.',
      '**Interfaces de analizadores ampliadas**: ahora son compatibles con analitos de tipo Plantillas y Microbiología.',
      '**Resultados de imágenes DICOM**: se habilita el nuevo tipo de resultado ImágenesDX para almacenar y visualizar imágenes en formato DICOM, principalmente de rayos X.',
    ],
  },
];
